import { render, staticRenderFns } from "./auditionManage.vue?vue&type=template&id=47c88222"
import script from "./auditionManage.vue?vue&type=script&lang=js"
export * from "./auditionManage.vue?vue&type=script&lang=js"
import style0 from "./auditionManage.vue?vue&type=style&index=0&id=47c88222&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports